import { fetchRequest } from '../base/fetchRequest.js';

class FetchRequest {
    reqConfig;
    constructor(reqConfig) {
        this.reqConfig = reqConfig;
    }
    async send() {
        return fetchRequest(this.reqConfig);
    }
}

export { FetchRequest };
//# sourceMappingURL=FetchRequest.js.map
